import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Location } from '@angular/common';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { filter, map, takeUntil, take } from 'rxjs/operators';
import { BaseAuthenticationService } from '../../../modules/auth/base-auth.service';
import { BaseButtonSize } from '../../../shared/components/button/base-button.component';
import { baseAuthActions, baseAuthSelectors } from '../../../_store';
import { BaseTokenInterface } from '../../../shared/interfaces/base-token-service.interface';
import { getLastChildRoute } from '../../../shared/helpers/base-get-last-route-child';

@Component({
  selector: 'base-error',
  templateUrl: './base-error.component.html',
})
export class BaseErrorComponent implements OnDestroy {
  is401 = false;
  is403 = false;
  is404 = false;
  destroy$ = new Subject<boolean>();
  buttonSize = BaseButtonSize;
  isAuth = false;

  constructor(
    private readonly router: Router,
    private readonly authService: BaseAuthenticationService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly store: Store,
    private readonly location: Location
  ) {
    this.router.events
      .pipe(
        takeUntil(this.destroy$),
        filter((event) => event instanceof NavigationEnd),
        map(() => getLastChildRoute(this.activatedRoute).snapshot)
      )
      .subscribe((routeSnapshot) => {
        this.is401 = routeSnapshot.data?.is401;
        this.is403 = routeSnapshot.data?.is403;
        this.is404 = routeSnapshot.data?.is404;
      });

    this.store
      .select(baseAuthSelectors.getUserInfo)
      .pipe(
        take(1),
        map((user) => user.data as BaseTokenInterface)
      )
      .subscribe((data) => {
        this.isAuth = !!data;
      });
  }

  goBack() {
    this.store.dispatch(baseAuthActions.navigateToLoginPage({}));
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
